// extracted by mini-css-extract-plugin
module.exports = {"history-page":"history_history-page__2DPi3","page-main":"history_page-main__3fOVZ"};